import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=e0b83df0&scoped=true&"
import script from "./Description.vue?vue&type=script&lang=js&"
export * from "./Description.vue?vue&type=script&lang=js&"
import style0 from "./Description.vue?vue&type=style&index=0&id=e0b83df0&lang=scss&scoped=true&"
import style1 from "./Description.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b83df0",
  null
  
)

export default component.exports